export const DEFAULT_WARNING_MODAL_INFO = {
  header: 'Leave this page without saving changes?',
  description: 'The changes you made to this page will not be saved.',
  confirmationButtonText: 'Leave',
  rejectionButtonText: 'Cancel',
};
